'use client';
import Link from 'next/link';

import { ErrorComponent } from '../components/error.component';
import styles from './not-found-v2.component.module.scss';

export const NotFoundV2 = () => {
  return (
    <ErrorComponent statusCode="404">
      <p>お探しのページは見つかりませんでした。</p>
      <p className={styles.topLink}>
        <Link href="/">トップへ</Link>
      </p>
    </ErrorComponent>
  );
};
